import { render, staticRenderFns } from "./OnboardingGamificado.vue?vue&type=template&id=2689cf28&scoped=true"
import script from "./OnboardingGamificado.vue?vue&type=script&lang=js"
export * from "./OnboardingGamificado.vue?vue&type=script&lang=js"
import style0 from "./OnboardingGamificado.vue?vue&type=style&index=0&id=2689cf28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2689cf28",
  null
  
)

export default component.exports